import { useEffect, useState } from "react";
import { LayoutGrid } from "lucide-react";
import { api } from "../lib/api";

const num = (n) => Number(n || 0).toLocaleString("en-US");

// Compact, read-only view of custom platform reports — embedded in the riders performance page.
export const PlatformReportsSection = ({ title = "أداء المنصات الأخرى" }) => {
  const [reports, setReports] = useState([]);
  useEffect(() => { api.customReports().then(setReports).catch(() => {}); }, []);
  if (!reports.length) return null;
  return (
    <div className="mt-6" data-testid="platform-reports-section">
      <h3 className="font-heading font-bold text-slate-800 mb-2 flex items-center gap-2"><LayoutGrid className="h-4 w-4 text-blue-600" /> {title}</h3>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        {reports.map((r) => (
          <div key={r.def_id} data-testid={`riders-platform-${r.def_id}`} className="rounded-2xl border border-slate-200 bg-white p-4">
            <div className="flex items-center justify-between mb-3">
              <span className="font-heading font-bold text-slate-900">{r.name}</span>
              <span className="text-xs text-slate-400">{r.latest_date || "—"} · {r.row_count} سجل</span>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
              {r.kpis.length === 0 ? (
                <div className="col-span-4 text-xs text-slate-400 text-center py-1">لا توجد مؤشرات رقمية</div>
              ) : r.kpis.map((k) => (
                <div key={k.key} className="rounded-xl bg-slate-50 border border-slate-100 p-2.5 text-center">
                  <div className="text-[11px] text-slate-400 truncate">{k.label}</div>
                  <div className="font-heading font-bold text-slate-800 font-mono-nums">{num(k.sum)}</div>
                  <div className="text-[10px] text-slate-400">متوسط {num(k.avg)}</div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
